module.exports = {
  "zones": {
    "Asia/Singapore": ["z", {
      "wallclock": 378691200000,
      "format": "+08",
      "abbrev": "+08",
      "offset": 28800000,
      "posix": 378664200000,
      "save": 0
    }, {
      "wallclock": -766972800000,
      "format": "+0730",
      "abbrev": "+0730",
      "offset": 27000000,
      "posix": -767005200000,
      "save": 0
    }, {
      "wallclock": -879638400000,
      "format": "+09",
      "abbrev": "+09",
      "offset": 32400000,
      "posix": -879665400000,
      "save": 0
    }, {
      "wallclock": -894153600000,
      "format": "+0730",
      "abbrev": "+0730",
      "offset": 27000000,
      "posix": -894180000000,
      "save": 0
    }, {
      "wallclock": -1073001600000,
      "format": "+0720",
      "abbrev": "+0720",
      "offset": 26400000,
      "posix": -1073028000000,
      "save": 0
    }, {
      "wallclock": -1167609600000,
      "format": "+0720",
      "abbrev": "+0720",
      "offset": 25200000,
      "posix": -1167634800000,
      "save": 1200000
    }, {
      "wallclock": -2038176000000,
      "format": "+07",
      "abbrev": "+07",
      "offset": 25200000,
      "posix": -2038200925000,
      "save": 0
    }, {
      "wallclock": -2177452800000,
      "format": "SMT",
      "abbrev": "SMT",
      "offset": 24925000,
      "posix": -2177477725000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 24925000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};